import React from 'react';

const Footer = () => {

  return (
    <footer style={{
      padding: '20px',
      textAlign: 'center', // Align text to the center
    }}>
      {/* Footer content */}
      <p style={{ fontSize: '18px' }}> {/* Larger text size */}
        Connect on <a href="https://www.linkedin.com/in/brian-sanchez-ramirez-368498202/" style={{ color: 'inherit', textDecoration: 'none', fontWeight: 'bold' }}>LinkedIn</a>
        {/* Hidden for now */}
        {/* <a href="#" style={{ color: 'black', textDecoration: 'none' }}>Behance</a> |  */}
        {/* <a href="#" style={{ color: 'black', textDecoration: 'none' }}>Dribbble</a> */}
      </p>
      <p style={{ fontSize: '18px', fontWeight: 'bold', }}> {/* Smaller text size */}
        Copyright © 2024 BAFSR •
      </p>
    </footer>
  );
};

export default Footer;
